var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list && _vm.list.length)?_c('div',{staticClass:"products sides-padding"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"products__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"products__list"},_vm._l((_vm.list),function(item,i){return _c('ProductCardComponent',{key:i,attrs:{"data":item}})}),1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }